/**
 * @generated SignedSource<<7f93af6896e35766b54065b6a7324b35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type statementUploader_PresignQuery$variables = {
  fileExtension: string;
};
export type statementUploader_PresignQuery$data = {
  readonly uploadPresign: {
    readonly signedUrl: string;
    readonly storageKey: string;
  } | null | undefined;
};
export type statementUploader_PresignQuery = {
  response: statementUploader_PresignQuery$data;
  variables: statementUploader_PresignQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileExtension"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "fileExtension",
    "variableName": "fileExtension"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "storageKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "statementUploader_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "statementUploader_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d358489ff1f6ab7aa8c12cad3c085503",
    "id": null,
    "metadata": {},
    "name": "statementUploader_PresignQuery",
    "operationKind": "query",
    "text": "query statementUploader_PresignQuery(\n  $fileExtension: String!\n) {\n  uploadPresign(fileExtension: $fileExtension) {\n    signedUrl\n    storageKey\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "78e0a404bcded4826dce3dbd94b3fbec";

export default node;
